import { useEffect, useRef } from "react"

export const useInterval = (
    callback: () => void,
    delay: number,
    shouldStop = false
) => {
    const savedCallback = useRef<() => void>()

    useEffect(() => {
        savedCallback.current = callback
    })

    useEffect(() => {
        if (!shouldStop) {
            const tick = () => {
                if (typeof savedCallback?.current !== "undefined") {
                    savedCallback?.current()
                }
            }

            const id = setInterval(tick, delay)
            return () => clearInterval(id)
        }
    }, [delay, shouldStop])
}
